import {FabricArt} from '~/common/fabric/types';

export type RecipientMessages = Record<string, string>;

export enum CardType {
  CARD = 'card',
  GIFTCARD = 'gift_card',
}

export enum EventStatus {
  NEW = 'new',
  CANCELED = 'cancelled',
  SCHEDULED = 'scheduled',
  SENDING = 'sending',
  CREATED = 'created',
  DRAFT = 'draft',
  VIDEOPROC = 'videoproc', // host wants to send, but video transcoding is still ongoing
  BLOCKED = 'blocked_host',
  PENDING = 'pending',
  FAILED = 'failed',
}

export type EcardAnalytics = {
  // biome-ignore lint/style/useNamingConvention: existing error
  tracking_data?: object;
  // biome-ignore lint/style/useNamingConvention: existing error
  tracking_product_type: string;
};

export type EcardSenderData = {
  // biome-ignore lint/style/useNamingConvention: existing error
  host_id: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  previously_purchased_offer?: boolean;
};

export type EventOptionsDesign = {
  background: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  background_image_desktop: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  background_image_mobile: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  overlay_id: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  overlay_video_mobile_vp9: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  overlay_video_desktop_vp9: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  overlay_video_mobile_h265: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  overlay_video_desktop_h265: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  reveal_id: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  reveal_video_mobile_vp9: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  reveal_video_desktop_vp9: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  reveal_video_mobile_h265: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  reveal_video_desktop_h265: string | null;
};

export type EventOptionsWrite = {
  // biome-ignore lint/style/useNamingConvention: existing error
  text_layer_back: string | null;
};

export type EventOptions = {
  design: EventOptionsDesign;
  // biome-ignore lint/style/useNamingConvention: existing error
  event_option_disable_rokt: boolean;
  write: EventOptionsWrite;
};

export type EcardTemplateData = {
  title: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  template_name: string;
};

export type EcardEventData = {
  // biome-ignore lint/style/useNamingConvention: existing error
  event_host_name: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  event_type: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  known_timezone_name: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  used_as: CardType;
  shortlink?: string;
  status: EventStatus;
  // biome-ignore lint/style/useNamingConvention: existing error
  send_count?: number;
  // biome-ignore lint/style/useNamingConvention: existing error
  send_on?: string | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  sent_on?: string | null;
  start?: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  start_datetime?: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  max_guest_list?: number;
  options: EventOptions;
  // biome-ignore lint/style/useNamingConvention: existing error
  fabric_design_data?: FabricArt;
  // biome-ignore lint/style/useNamingConvention: existing error
  system_generated: boolean;
  // biome-ignore lint/style/useNamingConvention: existing error
  user_saved: boolean;
  // biome-ignore lint/style/useNamingConvention: existing error
  is_pro: boolean | null;
  // biome-ignore lint/style/useNamingConvention: existing error
  gift_card_data: EcardGiftCardData;
};

export type Ecard = {
  id: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  event_data: EcardEventData;
  // biome-ignore lint/style/useNamingConvention: existing error
  template_data: EcardTemplateData;
  // biome-ignore lint/style/useNamingConvention: existing error
  sender_data: EcardSenderData;
  analytics: EcardAnalytics;
  // biome-ignore lint/style/useNamingConvention: existing error
  is_ecard: boolean;
};
// TODO: this is the domain Event model, we should create the whole type based on it if want to be more precise
export type WindowEviteEvent = Omit<EcardEventData, 'event_host_name'> &
  EcardSenderData &
  EcardTemplateData & {
    id: string;
    // biome-ignore lint/style/useNamingConvention: existing error
    host_name: string;
    // biome-ignore lint/style/useNamingConvention: existing error
    tracking_data?: object;
    // biome-ignore lint/style/useNamingConvention: existing error
    host_ids?: string[];
    // biome-ignore lint/style/useNamingConvention: existing error
    is_fabric_premium?: boolean;
    // biome-ignore lint/style/useNamingConvention: existing error
    is_host_viewing?: boolean;
    // biome-ignore lint/style/useNamingConvention: existing error
    is_cohost_viewing?: boolean;
  };

export type AssetMedia = {label: string; url: string};
export type Asset = {
  id: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  display_name: string;
  keywords: string[];
  visible: boolean;
  media: AssetMedia[];
  // biome-ignore lint/style/useNamingConvention: existing error
  primary_categories: string[];
  // biome-ignore lint/style/useNamingConvention: existing error
  asset_groups: string[];
  brand: string | null;
};

export type Envelope = {
  id: string;
  name: null;
  // biome-ignore lint/style/useNamingConvention: existing error
  display_name: string;
  image: string;
  icon: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  flap_down_image: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  text_color: string;
  blank: string;
  stamps: string[] | null;
  visible: boolean;
  liners: string[] | null;
  liner: string | null;
  stamp: string | null;
};

export type Assets = {
  backgrounds: Asset[];
  envelopes: Envelope[];
  liners: Asset[];
  overlays: Asset[];
  reveals: Asset[];
  stamps: Asset[];
  stickers: Asset[];
};

export type GetAssetsRequestParams = {
  assetGroups: string[];
  primaryCategories: string[];
  templateId: string;
};

export type FlipBehavior = 'disable' | 'force' | 'auto';
